export const FEATURE_IS_ALLOWED_OSM = false;
